export enum ImageUploadError {
    LargeImage = 'Your image is larger than the recommended size. This may distort your email.',
}

export const ACCOUNT_DUNNING = 'dunning'

export const SERVER_ERROR_MESSAGE = 'Something went wrong, try again or contact Customer Success'
export const INVALID_IMAGE_URL_MESSAGE = 'Please double check the url is linked to an image'

// Gallery pagination constants
// Should match backend DEFAULT_GALLERY_PAGE_SIZE
export const GALLERY_PAGE_SIZE = 20
